import React from 'react';
import { Typography } from '@mui/material';

const Settings: React.FC = () => {
  return <Typography>Settings page - coming soon</Typography>;
};

export default Settings;
